/**
 * 강사 → 원장 전환 mutation 훅
 *
 * 백엔드 contract: packages/@vlab-corporation/firebase-functions/src/auth/upgrade-to-owner.ts
 * 로그인한 강사 본인이 초대 코드를 입력해 자신의 role을 owner로 전환한다.
 */

import { useMutation } from "@tanstack/react-query";
import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "@/config/firebase";

interface UpgradeToOwnerRequest {
  inviteCode: string;
}

interface UpgradeToOwnerResponse {
  success: true;
  status: "upgraded" | "already-owner";
  role: "owner";
}

/** 전환 시 외부에서 전달하는 파라미터 */
export interface UpgradeToOwnerParams {
  inviteCode: string;
}

export function useUpgradeToOwner() {
  return useMutation({
    mutationFn: async (params: UpgradeToOwnerParams) => {
      const fn = httpsCallable<UpgradeToOwnerRequest, UpgradeToOwnerResponse>(
        getFirebaseFunctions(),
        "upgradeToOwner",
      );
      const result = await fn(params);
      return result.data;
    },
  });
}
